module.exports = __webpack_public_path__ + "media/img/marquee/marquee-solutions-detail-5a0ca5cba4c14e643cb4cdf354fb63f1.jpg";